module.exports = __webpack_public_path__ + "img/1F1F2-1F1F8.987a4911.svg";